import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let nestingExample = `# Backticks are awkward to nest and require escaping
outer=\`echo "inner: \\\`date\\\`"\`

# $() nests cleanly, no escaping needed
outer=$(echo "inner: $(date)")`

let multilineExample = `files=$(find . -name "*.log")
echo "$files"
# Preserves embedded newlines when double-quoted`

export default function CommandSubstitution() {
    return (
        <div className={globalStyles.article}>
            <h1>Command substitution</h1>
            <p>Captures a command's stdout as text, trimming trailing newlines.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Notes</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>{"$(cmd)"}</code></td>
                        <td>Preferred — nests cleanly, easier to read</td>
                    </tr>
                    <tr>
                        <td><code>{"`cmd`"}</code></td>
                        <td>Legacy backtick form — still POSIX, but nesting needs escaped backticks</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Nesting</h3>
            <SyntaxHighlighter
                children={nestingExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Always quote the result</h3>
            <p>An unquoted <code>$(cmd)</code> is subject to word-splitting and glob expansion, same as any
                other unquoted variable — quote it to preserve embedded whitespace and newlines.</p>
            <SyntaxHighlighter
                children={multilineExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
